export default __webpack_public_path__ + "static/media/html.de14fa60.svg";